
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 36 36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.765 36H8.233A8.233 8.233 0 010 27.767V8.235A8.234 8.234 0 018.233 0h19.532A8.236 8.236 0 0136 8.235v19.532A8.235 8.235 0 0127.765 36","fill":"#00DCF7"}}),_c('path',{attrs:{"d":"M18.248 13.284c2.129 0 3.854-1.734 3.854-3.874a3.864 3.864 0 00-3.854-3.87c-2.13 0-3.853 1.733-3.853 3.87 0 2.14 1.724 3.874 3.853 3.874zM16.688 30.735l-.322-.236a2.853 2.853 0 01-.627-3.976l8.904-11.8a2.826 2.826 0 013.959-.63l.322.237a2.857 2.857 0 01.626 3.977l-8.904 11.797a2.826 2.826 0 01-3.958.631zM13.25 26.223l1.949-2.551c1.054-1.246 1.444-2.727.525-3.998l-3.872-4.951a2.823 2.823 0 00-3.956-.63l-.324.235a2.858 2.858 0 00-.626 3.977l4.065 5.207 2.239 2.71z","fill":"#fff"}})])
          )
        }
      }
    